import React from "react";
import logo from "../assets/optimized/echo-logo-wide-96.webp";
import { Icon } from "./Icon";

const StepPreview = ({ variant }) => {
  if (variant === "forward") {
    return (
      <div className="how-it-works-phone how-it-works-phone-forward" aria-hidden="true">
        <div className="how-phone-topbar">
          <span className="how-phone-title">Send to</span>
        </div>
        <div className="how-phone-search"></div>
        <div className="how-contact-row how-contact-row-active">
          <span className="how-contact-avatar">
            <img
              src={logo}
              alt="Echo MSG logo"
              className="how-contact-logo"
              decoding="async"
              height="81"
              loading="lazy"
              width="96"
            />
          </span>
          <span className="how-contact-name">Echo MSG</span>
          <span className="how-contact-check">
            <Icon name="check" />
          </span>
        </div>
        <div className="how-contact-row">
          <span className="how-contact-avatar how-contact-avatar-muted"></span>
          <span className="how-contact-line how-contact-line-long"></span>
        </div>
        <div className="how-contact-row">
          <span className="how-contact-avatar how-contact-avatar-muted"></span>
          <span className="how-contact-line"></span>
        </div>
        <div className="how-phone-compose">
          <span className="how-phone-compose-bar"></span>
          <span className="how-phone-forward-label">Forward</span>
        </div>
      </div>
    );
  }

  if (variant === "transcript") {
    return (
      <div className="how-it-works-phone how-it-works-phone-transcript" aria-hidden="true">
        <div className="how-chat-header">
          <span className="how-chat-brand">
            <img
              src={logo}
              alt="Echo MSG logo"
              className="how-chat-logo"
              decoding="async"
              height="81"
              loading="lazy"
              width="96"
            />
          </span>
          <span className="how-chat-name">Echo MSG</span>
        </div>
        <div className="how-mini-audio-bubble">
          <span className="how-mini-play">
            <Icon name="play" />
          </span>
          <span className="how-mini-wave"></span>
        </div>
        <div className="how-mini-transcript-card message-bubble-received">
          <span className="how-mini-line how-mini-line-wide"></span>
          <span className="how-mini-line"></span>
          <span className="how-mini-line how-mini-line-wide"></span>
          <span className="how-mini-line"></span>
          <span className="how-mini-line how-mini-line-short"></span>
          <span className="how-mini-line how-mini-line-wide"></span>
        </div>
        <div className="how-phone-bottom-bar">
          <span className="how-phone-bottom-icon"></span>
          <span className="how-phone-bottom-field"></span>
          <span className="how-phone-bottom-dots"></span>
        </div>
      </div>
    );
  }

  return (
    <div className="how-it-works-phone how-it-works-phone-summary" aria-hidden="true">
      <div className="how-chat-header">
        <span className="how-chat-brand">
          <img
            src={logo}
            alt="Echo MSG logo"
            className="how-chat-logo"
            decoding="async"
            height="81"
            loading="lazy"
            width="96"
          />
        </span>
        <span className="how-chat-name">Echo MSG</span>
      </div>
      <div className="how-mini-audio-bubble">
        <span className="how-mini-play">
          <Icon name="play" />
        </span>
        <span className="how-mini-wave how-mini-wave-short"></span>
      </div>
      <div className="how-mini-summary-block message-bubble-received">
        <span className="how-mini-line how-mini-line-wide"></span>
        <span className="how-mini-line"></span>
        <span className="how-mini-line how-mini-line-short"></span>
      </div>
      <div className="how-mini-summary-pill message-bubble-received">
        <span className="how-mini-summary-label">Summary</span>
        <span className="how-mini-summary-line"></span>
      </div>
      <div className="how-mini-summary-pill how-mini-summary-pill-secondary message-bubble-received">
        <span className="how-mini-summary-label">Call to action</span>
        <span className="how-mini-summary-line how-mini-summary-line-short"></span>
      </div>
      <div className="how-phone-bottom-bar">
        <span className="how-phone-bottom-icon"></span>
        <span className="how-phone-bottom-field"></span>
        <span className="how-phone-bottom-dots"></span>
      </div>
    </div>
  );
};

export const HowItWorks = ({ data }) => {
  const steps = data?.steps || [];

  return (
    <section id="how-it-works" className="landing-section how-it-works-section">
      <div className="container">
        <div className="section-heading text-center how-it-works-heading">
          <h2>{data?.title || "How it Works"}</h2>
          <p>{data?.paragraph || "No app to download. Works inside WhatsApp."}</p>
        </div>

        <div className="row how-it-works-grid">
          {steps.map((step, index) => (
            <div key={`${step.title}-${index}`} className="col-sm-6 col-md-4">
              <div className="how-it-works-card">
                <div className="how-it-works-stage">
                  <StepPreview variant={step.variant} />
                </div>
                <h3>{step.title}</h3>
                <p>{step.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
